import type { ReactNode } from 'react';

import { log } from 'src/app/utils/logging';
import { ErrorPageRecoverable } from 'src/app/v2/pages/ErrorPageRecoverable';
import { useHirerAccountAndUserDataQuery } from 'src/graphql/generated';

interface ProviderProps {
  children: ReactNode;
}

export const HirerAccountAndUserDataLoader = ({ children }: ProviderProps) => {
  const { data, error } = useHirerAccountAndUserDataQuery({
    variables: {
      // advertiserNation param has been deprecated and will be removed by the Monetization team in the future.
      advertiserNation: 'deprecated',
    },
    fetchPolicy: 'cache-and-network',
  });

  if (error) {
    log.error(
      'HirerAccountAndUserDataLoader | Error fetching hirer account and user data',
      { error },
    );
  }

  if (error && !data) {
    return <ErrorPageRecoverable />;
  }

  if (!data) {
    return null;
  }

  return <>{children}</>;
};
